let handler = null;

/**
 * Enregistre la fonction à appeler lorsqu’un 403 survient.
 */
export function registerAccessDeniedHandler(fn) {
  handler = fn;
}

/**
 * Déclenche l’événement AccessDenied (appel du handler s’il existe).
 */
export function triggerAccessDenied() {
  if (handler) handler();
}
